import { useState } from "react";
import { useDispatch } from "react-redux";
import { ModalType } from "../../constants/enums";
import { openOrCloseModal, showModalHeader } from "../../../../store/modalActionsSlice";
import { ColorRing } from "react-loader-spinner";
import { toast, ToastContainer, TypeOptions } from "react-toastify";
import { hooks } from "botframework-webchat";
import { storeFeedback } from "../../functions/createFeedbackHistory";
import './Feedback.css'

interface FeedbackProps {
  token: string
}

const Spinner = () => {
  return (
    <>
      <ColorRing
        visible={true}
        height="25"
        width="25"
        ariaLabel="color-ring-loading"
        wrapperStyle={{}}
        wrapperClass="color-ring-wrapper"
        colors={['#B0B0B0', '#B0B0B0', '#B0B0B0', '#B0B0B0', '#B0B0B0']}
      />
    </>
  )
}

export const Feedback = ({ token }: FeedbackProps) => {
  let dispatch = useDispatch();
  const [feedback, setFeedback] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [feedbackWasSent, setFeedbackWasSent] = useState<boolean>(false);

  const { usePostActivity } = hooks;
  const postActivity = usePostActivity();

  const onFeedbackChange = (value: string) => {
    setFeedback(value);
  }

  const dispatchToast = async (text: string, type: TypeOptions) =>
    toast(text, {
      theme: "colored",
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      position: "bottom-left",
      autoClose: 5000,
      type
  });


  const sendFeedback = async () => {
    setIsLoading(true)
    alert('sendFeedback')
    const activityId = localStorage.getItem('activityId')
    const conversationId = activityId?.split('|')[0]

    postActivity({
      type: "messageReaction",
      activityID: activityId,
      reactionsAdded: [{ id: activityId, type: "dislike" }],
    } as any);


    const response = await fetch(
      `https://directline.botframework.com/v3/directline/conversations/${conversationId}/activities`,
      {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "type": "message",
          "value": {
              "action": "send_feedback_to_bot",
              "message": "Feedback from Dislike!",
              "feedback": feedback
          }
        })
      }
    );

    if (!response.ok) {
      setIsLoading(false)
      await dispatchToast(`Direct Line token API call failed with status ${response.status}`, "error");
      throw new Error(
        `Direct Line token API call failed with status ${response.status}`
      );
    }

    const responseJson = await response.json();
    storeFeedback(activityId || '',  responseJson.id);
    
    setIsLoading(false)
    dispatch(showModalHeader(false))
    setFeedbackWasSent(true)
    setTimeout(() => {
      dispatch(openOrCloseModal({ isOpen: false, modalType: ModalType.Feedback }))
      dispatch(showModalHeader(true))
    }, 4000);
  }


  return (
    <>
      <div style={{ display: feedbackWasSent ? 'none' : 'block', width: '100%' }}>
        <div className="textarea-container">
          <textarea id="feedback" placeholder=" " required onChange={(e) => onFeedbackChange(e.target.value)}></textarea>
          <label htmlFor="feedback">Feedback</label>
          {+feedback.length === 0 && <span className="error-message">Feedback is required.</span> }
        </div>
        <div className="send-feedback--button__container">
          <button className={`send-feedback--button ${isLoading ? 'send-feedback--loading' : ''}`}
            disabled={+feedback.length === 0 || isLoading} 
            onClick={sendFeedback}> {isLoading && <Spinner />} Send feedback</button>
          <ToastContainer />
        </div>
      </div>

      <div style={{ display: feedbackWasSent ? 'block' : 'none' }} className="feedback-content-success-message">
        <img src="static/images/icons/Ok.png" className="ok-icon" />
        <h2 className="thank-you-title">Thank you!</h2>
        <p className="feedback-bot-message">Now I know this answer is INCORRECT! Thanks for your feedback!</p>
        <p className="feedback-bot-message">Your feedback has been registered for analysis assss:</p>
        <p className="feedback-user-message">Your feedback is here: {feedback}</p>
      </div>
    </>
  );
};
